/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_No_CameraInputs */

const en_mobile_scan_no_camera = /** @type {(inputs: Mobile_Scan_No_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No camera available`)
};

const es_mobile_scan_no_camera = /** @type {(inputs: Mobile_Scan_No_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cámara disponible`)
};

/**
* | output |
* | --- |
* | "No camera available" |
*
* @param {Mobile_Scan_No_CameraInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_no_camera = /** @type {((inputs?: Mobile_Scan_No_CameraInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_No_CameraInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_no_camera(inputs)
	return en_mobile_scan_no_camera(inputs)
});